import { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router";

import routes from './routes';
import { getCookie } from './utils';

function App() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    // TODO: check if JWT is expired
    const jwtToken = getCookie('jwtToken');
    const visitorPage = ['/', '/signUp', '/verifyEmail', '/emailVerified', '/users/confirmation'].includes(pathname);

    if (jwtToken.length === 0 && !visitorPage) {
      navigate('/');
    }
  }, [pathname])
  
  return (
    <Routes>
      {routes.map((route, key) => {
        return <Route key={key} {...route} />
      })}
    </Routes>
  );
}

export default App;
